import { call, put, takeLatest, select } from 'redux-saga/effects';

import { APPLICATION_CONSTANTS, PATHS, BROWSER_URLS, COMPANY_DETAILS_CONSTS } from 'AppConstants';
import { COMPANY_DETAILS_CONSTANT } from '../actionConstants';
import { updateCompanyDetailsFailed, updateCompanyDetailsSuccess, getCurrenciesSuccess, getCurrenciesFailed, getApiKeysSuccess, updateApiKeysSuccess, updateApiKeysFailed, getApiKeysFailed } from '../actions/CompanyDetailsActions';
import { hidePop, updatePopup } from '../actions/popupActions';
import { saveServerLogs } from 'UtilityComponents/Util';
import { formatCurrencyData, formatKeyDataFields } from 'UtilityComponents/companyDetailsUtil';
import { postUpdatedDetails, getCurrenciesApi, getClientKeyApi, updateClientKeyApi } from 'apis/companyDetailsApis';
import { modalChildren } from '../../companyDetails/config';
import { updateOrgSuccess } from '../actions/bizHeaderActions';
import { getApiFields } from 'reduxStore/selectors/companyDtlsSelectors';

function* updateCompanyDetails({ payload }) {
	const { name, panCard, currency, isCurrencyUpdated } = payload;
	const postdata = {
		emailId: localStorage.getItem('userEmail'),
		organizationName: name,
		panNo: panCard,
		currency
	};
	const popData = {
		showPop: true,
		popData: false
	};
	try {
		const response = yield call(postUpdatedDetails, postdata);
		const resp = response && response.data;
		if (resp && resp.organization) {
			yield put(updateOrgSuccess(resp.organization));
			yield put(updateCompanyDetailsSuccess());
			const obj = {
				heading: modalChildren.heading,
				content: isCurrencyUpdated ? modalChildren.isCurrencyUpdate : modalChildren.nonCurrencyUpdate,
				apiStatus: modalChildren.status,
				isFooter: isCurrencyUpdated,
				redirectionUrl: BROWSER_URLS.POLICY_PAGE,
				pageName: modalChildren.pageName
			};
			popData.popData = obj;
		}
	} catch (error) {
		popData.popData = {
			heading: APPLICATION_CONSTANTS.GENERIC_ERROR_HEADING,
			content: APPLICATION_CONSTANTS.GENERIC_API_ERROR,
			apiStatus: 'ERR_DEFAULT',
			isFooter: false
		};
		yield put(updateCompanyDetailsFailed());
		saveServerLogs(error.stack, 'error', PATHS.SAVE_ORGANIZATION_DETAILS);
	} finally {
		yield put(updatePopup(popData));
	}
}

function* getCurrencies() {
	let error = false;
	try {
		const response = yield call(getCurrenciesApi);
		const respData = response && response.data;
		if (respData) {
			const cur = formatCurrencyData(respData?.currencies);
			yield put(getCurrenciesSuccess(cur));
		} else {
			error = true;
		}
	} catch (error) {
		saveServerLogs(error.stack, 'error', PATHS.SAVE_ORGANIZATION_DETAILS);
		error = true;
	} finally {
		if (error) {
			yield put(getCurrenciesFailed());
		}
	}
}

function* getApiKeysData() {
	let error = false;
	try {
		const response = yield call(getClientKeyApi);
		const respData = response && response.data;
		if (respData && respData.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
			const apiFields = yield select(getApiFields);
			const data = formatKeyDataFields(respData, apiFields);
			yield put(getApiKeysSuccess(data));
		} else {
			error = true;
		}
	} catch (err) {
		saveServerLogs(err.stack, 'error', PATHS.GET_API_KEYS);
		error = true;
	} finally {
		if (error) {
			yield put(getApiKeysFailed());
		}
	}
}

function* updateKeysData({ payload }) {
	let error = false;
	try {
		const response = yield call(updateClientKeyApi, payload);
		const respData = response && response.data;

		if (respData.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
			yield put(hidePop());
			yield getApiKeysData();
		} else {
			error = respData.message;
		}
	} catch (error) {
		saveServerLogs(error.stack, 'error', PATHS.UPDATE_API_KEYS);
		error = true;
	} finally {
		if (error) {
			yield put(updatePopup({
				showPop: true,
				popData: {

					heading: APPLICATION_CONSTANTS.GENERIC_ERROR_HEADING,
					content: error || APPLICATION_CONSTANTS.GENERIC_API_ERROR,

					apiStatus: 'ERR_DEFAULT',
					isFooter: false
				}
			}));
			yield put(updateApiKeysFailed({
				apiError: COMPANY_DETAILS_CONSTS.UPDATE_KEYS,
				apiSuccess: false
			}));
		}
	}
}

export default [
	takeLatest(COMPANY_DETAILS_CONSTANT.UPDATE_COMPANY_DETAILS_CALLED, updateCompanyDetails),
	takeLatest(COMPANY_DETAILS_CONSTANT.GET_CURRENCIES_API, getCurrencies),
	takeLatest(COMPANY_DETAILS_CONSTANT.GET_API_KEYS, getApiKeysData),
	takeLatest(COMPANY_DETAILS_CONSTANT.UPDATE_API_KEYS, updateKeysData)
];
